import { StatePropertyRef } from '../../canvas/ExtendableStore';


export type VoteRankingMode = 'object' | 'topic' | 'default';
export interface VoteRankingInfo {
    enabled: boolean;
    mode: VoteRankingMode;
}

export const VoteRankingInfo = StatePropertyRef<VoteRankingInfo>('voteRanking');

export const CreateVoteRankingInfo = (enabled: boolean, mode: VoteRankingMode = 'default') =>
    ({ enabled, mode }) as VoteRankingInfo;

export const DefaultVoteRankingInfo = (() => {
    const d = CreateVoteRankingInfo(false);
    return () => d;
})();
